import React, { useMemo } from 'react';
import { translate as t } from 'hooks/useTranslations';
import GridSection, { ColumnDef } from 'components/_layouts/GridSection';
import { GridCellParams, GridRowSelectionModel } from '@mui/x-data-grid-pro';
import _ from 'lodash';
import datetimeHelper from 'helpers/datetimeHelper';

interface AssignmentHistoryProps {
    assignedToGroups: { id: string, name: string, assignedAt: string; }[],
    rowSelectionModel: GridRowSelectionModel,
    setRowSelectionModel: (newRowSelectionModel: GridRowSelectionModel) => void,
    groupSearchTerm: string,
};

const AssignmentHistoryList: React.FC<AssignmentHistoryProps> = ({ assignedToGroups, rowSelectionModel, setRowSelectionModel, groupSearchTerm }) => {
    const organizationColumns: ColumnDef = useMemo(
        () => ({
            agency: {
                header: t('dtbs.assignments.history.columns.group', 'Group'),
                flex: 2,
                renderer: (params: GridCellParams) => {
                    const row = params.row;
                    if (!row) return null;
                    return <span>{row.name}</span>;
                },
                valueGetter: (value: any, row: any) => {
                    return row.name;
                },
            },
            distributionDate: {
                header: t('dtbs.assignments.history.columns.assignedDate', 'Assigned Date'),
                flex: 2,
                renderer: (params: GridCellParams) => {
                    const row = params.row;
                    if (!row) return null;
                    return <span>{datetimeHelper.formatDate(row.assignedAt) ?? '-'}</span>;
                },
                valueGetter: (value: any, row: any) => {
                    return datetimeHelper.formatDate(row.assignedAt) ?? '-';
                },
            },
        }),
        [t]
    );

    return (
        <GridSection
            columns={organizationColumns}
            data={assignedToGroups}
            totalCount={assignedToGroups.length}
            gridProps={{
                getRowId: (row: any) => row.id,
                checkboxSelection: true,
                onRowSelectionModelChange: (newRowSelectionModel: GridRowSelectionModel) => {
                    setRowSelectionModel(newRowSelectionModel);
                },
                rowSelectionModel,
                filterModel: {
                    items: [{ field: 'name', operator: 'contains', value: groupSearchTerm }],
                },
            }}
        />
    );
};

export default AssignmentHistoryList;
